import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { SidebarHeader } from './SidebarHeader'

export const SidebarHeaderRegistration = createRegisterableComponent(
    'sidebar-header',
    (props) => {
        return <SidebarHeader />
    },
)
